import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';

import {
    hasAcceptedInstitutionLinkDisclosuresAtom,
    isShowingInstitutionLinkDisclosuresAtom,
} from '../state/HolisticAtoms';

const useInstitutionConnectDisclosure = () => {
    const [showConnector, setShowConnector] = useState<boolean>(false);

    const hasAcceptedInstitutionLinkDisclosures = useAtomValue(
        hasAcceptedInstitutionLinkDisclosuresAtom,
    );
    const setIsShowingInstitutionLinkDisclosures = useSetAtom(
        isShowingInstitutionLinkDisclosuresAtom,
    );

    const [
        isAwaitingDisclosuresAcceptance,
        setIsAwaitingDisclosuresAcceptance,
    ] = useState(false);

    // This hook is key for handling the interruption/continuation of showing our
    // connection disclosures modal before proceeding with the actual connection process
    useEffect(() => {
        if (
            hasAcceptedInstitutionLinkDisclosures &&
            isAwaitingDisclosuresAcceptance
        ) {
            setShowConnector(true);
        }
    }, [
        hasAcceptedInstitutionLinkDisclosures,
        isAwaitingDisclosuresAcceptance,
    ]);

    return {
        hasAcceptedInstitutionLinkDisclosures,
        setIsAwaitingDisclosuresAcceptance,
        setIsShowingInstitutionLinkDisclosures,
        showConnector,
    };
};

export default useInstitutionConnectDisclosure;
